import * as actionTypes from "../actionTypes/Index";

import { IActionType } from "../../interfaces/Index";
import { liveOpsInitialState } from "./InitialState";

const initialState = { ...liveOpsInitialState };

export default function liveopsReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.UPDATE_DELIVERY_DATE_IN_LIVEOPS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
      });
    }
    case actionTypes.UPDATE_DELIVERY_DATE_IN_LIVEOPS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }
    case actionTypes.UPDATE_DELIVERY_DATE_IN_LIVEOPS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        deliveryDateUpdated: true,
      });
    }

    default:
      return state;
  }
}
